import { render, staticRenderFns } from "./LandingPageCarousel.vue?vue&type=template&id=a2720fce&scoped=true"
import script from "./LandingPageCarousel.vue?vue&type=script&lang=js"
export * from "./LandingPageCarousel.vue?vue&type=script&lang=js"
import style0 from "./LandingPageCarousel.vue?vue&type=style&index=0&id=a2720fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2720fce",
  null
  
)

export default component.exports